
import { Link } from "react-router-dom";
import Header from "../components/feature/Header";
import Footer from "../components/feature/Footer";
import SEO from "../utils/seo";

const NotFound = () => {
  return (
    <>
      <SEO
        title="Page Not Found - Starlight Motors Mobile Detailing"
        description="The page you're looking for doesn't exist. Return to Starlight Motors homepage for professional mobile car detailing services in Melbourne."
        canonical={`${import.meta.env.VITE_SITE_URL || 'https://starlightmotors.com.au'}/404`}
      />
      <div className="min-h-screen bg-white flex flex-col">
        <Header />
        <main className="flex-1 flex items-center justify-center px-4">
          <div className="text-center max-w-md">
            <h1 className="text-6xl font-bold text-blue-600 mb-4">404</h1>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">Page Not Found</h2>
            <p className="text-gray-600 mb-8">
              Sorry, the page you're looking for doesn't exist. Let's get you back to our car detailing services.
            </p>
            <Link
              to="/"
              className="inline-flex items-center px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors"
            >
              <i className="ri-home-line mr-2"></i>
              Back to Home
            </Link>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
};

export default NotFound;
